import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/logo.png';

const NAV_LINKS = [
  { to: '/', label: 'Home', exact: true },
  { to: '/register', label: 'Register' },
  { to: '/events', label: 'Events' },
  { to: '/profile', label: 'Profile' },
  { to: '/categories', label: 'Categories' },
  { to: '/login', label: 'Sign In' },
];

const SiteNav: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const isActive = (to: string, exact?: boolean) => {
    if (exact) return location.pathname === to;
    if (to === '/') return location.pathname === '/';
    return location.pathname === to || location.pathname.startsWith(`${to}/`);
  };

  const linkClass = (to: string, exact?: boolean) =>
    isActive(to, exact)
      ? 'text-white bg-gray-800/60 border-l-4 border-primary'
      : 'text-gray-400 hover:text-white hover:bg-gray-800/40 border-l-4 border-transparent';

  return (
    <nav className="app-site-nav relative z-50">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center min-w-0">
            <Link to="/" className="flex items-center flex-shrink-0">
              <img src={logo} alt="GOMTB Logo" className="h-8 w-auto" />
            </Link>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              {NAV_LINKS.map(({ to, label, exact }) => (
                <Link
                  key={to}
                  to={to}
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                    isActive(to, exact)
                      ? 'border-primary text-white'
                      : 'border-transparent text-gray-400 hover:border-gray-500 hover:text-gray-200'
                  }`}
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <button
            type="button"
            className="sm:hidden flex items-center justify-center w-10 h-10 text-gray-300 hover:text-white rounded-lg hover:bg-gray-700 transition-colors"
            onClick={() => setMenuOpen((open) => !open)}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} className="text-xl" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <>
          <button
            type="button"
            className="fixed inset-0 bg-black/50 sm:hidden z-40"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          />
          <div className="absolute top-full left-0 right-0 bg-header border-t border-gray-700 shadow-lg sm:hidden z-50">
            <div className="py-2">
              {NAV_LINKS.map(({ to, label, exact }) => (
                <Link
                  key={to}
                  to={to}
                  className={`block px-4 py-3 text-base font-medium transition-colors ${linkClass(to, exact)}`}
                  onClick={() => setMenuOpen(false)}
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
        </>
      )}
    </nav>
  );
};

export default SiteNav;
